import { render } from "./ElementTypesCount.vue?vue&type=template&id=a37539ba&scoped=true"
import script from "./ElementTypesCount.vue?vue&type=script&lang=js"
export * from "./ElementTypesCount.vue?vue&type=script&lang=js"

import "./ElementTypesCount.vue?vue&type=style&index=0&id=a37539ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37539ba"]])

export default __exports__